import dynamic from 'next/dynamic'

const TrustBox = dynamic(() => import('./TrustBox'), {
    ssr: false,
})

export default TrustBox
